import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerService } from 'ngx-spinner';
import { HeaderService } from 'src/app/core/services/header.service';
import { CloudProvider } from '../../../../core/models/cloudProvider';
import { DeploymentService } from '../../../../core/services/deployment.service';
import { AddDeploymentComponent } from '../../../deployment/modals/add-deployment/add-deployment.component';

@Component({
  selector: 'app-attach-deployment',
  templateUrl: './attach-deployment.component.html',
  styleUrls: ['./attach-deployment.component.scss'],
})
export class AttachDeploymentComponent implements OnInit {
  attachDeploymentForm: UntypedFormGroup = new UntypedFormGroup({
    deploymentName: new UntypedFormControl(null, [Validators.required]),
  });
  deploymentNames: string[] = [];
  cloudProviders: CloudProvider[];

  constructor(
    public dialog: MatDialogRef<AttachDeploymentComponent>,
    private _headerService: HeaderService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      wsName: string[];
      depNames: string[] | null;
      cloudProvider: string | null;
    },
    public _dialog: MatDialog,
    public depService: DeploymentService,
    private snackbar: MatSnackBar
  ) {}

  ngOnInit(): void {
    if (this.data.cloudProvider) {
      this.deploymentNames = this._headerService.getQuickAccessDeploymentNamesForSpecificCloudProvider(this.data.cloudProvider);
    }
    else {
      this.deploymentNames = this._headerService.getQuickAccessDeploymentNames();
    }
    this.depService
      .getAllCloudProviders(
      )
      .subscribe((data) => {
        this.cloudProviders = <CloudProvider[]>JSON.parse(JSON.stringify(data));
        if (this.data.cloudProvider) {
          this.cloudProviders = this.cloudProviders?.filter(cp => cp?.providerName?.toLowerCase()?.indexOf(this.data.cloudProvider?.toLowerCase()) != -1 && cp?.providerName?.toLowerCase()?.indexOf('vdi') != -1)
        }
      });
    if(this.data.depNames){
      this.deploymentNames = this.deploymentNames.filter(dep => !this.data.depNames.includes(dep));
    }
  }

  onClose() {
    this.dialog.close(false);
  }

  onSubmit() {
    this.dialog.close(this.attachDeploymentForm.value.deploymentName.toString());
  }

  addDeployment(providerValue: number, providerName: string) {
    const dialogRef = this._dialog.open(AddDeploymentComponent, {
      width: '60%',
      autoFocus: true,
      disableClose: true,
      data: { provider :new CloudProvider(providerName, providerValue.toString(), "", "", "", "", "") }
    })
    dialogRef.afterClosed().subscribe(async res => {
      if (res) {
        this.snackbar.open('Deployment Created Successfully', 'Ok',
          {
            duration: 3000
          })
        this.deploymentNames.push(res![0].depValue);
        this.attachDeploymentForm.controls['deploymentName'].setValue([res![0].depValue]);
      }
    })
  }
}
